import { createElement, useState } from 'react';
import classNames from 'classnames';
export const ColorfulSidebar = props => {
    const [interacting, setInteracting] = useState(false);
    const classPrefix = `au-indexbar`;
    return (createElement("div", { className: classNames(`${classPrefix}-sidebar`, {
            [`${classPrefix}-sidebar-interacting`]: interacting,
        }), onMouseDown: () => {
            setInteracting(true);
        }, onMouseUp: () => {
            setInteracting(false);
        }, onTouchStart: () => {
            setInteracting(true);
        }, onTouchEnd: () => {
            setInteracting(false);
        }, onTouchMove: e => {
            if (!interacting)
                return;
            const { clientX, clientY } = e.touches[0];
            const target = document.elementFromPoint(clientX, clientY);
            if (!target)
                return;
            const { index } = target.dataset;
            if (index) {
                props.onActive(index);
            }
        } }, props.indexItems?.map((dataIndex) => {
        const active = dataIndex === props?.activeIndex;
        return (createElement("div", { className: `${classPrefix}-sidebar-row`, onMouseDown: () => {
                props.onActive(dataIndex);
            }, onTouchStart: () => {
                props.onActive(dataIndex);
            }, onMouseEnter: () => {
                if (interacting) {
                    props.onActive(dataIndex);
                }
            }, "data-index": dataIndex, key: dataIndex },
            interacting && active && (createElement("div", { className: `${classPrefix}-sidebar-bubble` }, dataIndex)),
            createElement("div", { className: classNames(`${classPrefix}-sidebar-item`, {
                    [`${classPrefix}-sidebar-item-active`]: active,
                }), "data-index": dataIndex },
                createElement("div", null, dataIndex))));
    })));
};
